import { StyledMightyFuSubProduct, StyledQuantity } from './style';
import { useEffect, useMemo, useState } from 'react';
import tooltipTitleImage from 'assets/MightyFu/egg.png';
import { IExtendedTooltipProps } from 'components/TooltipTemplate/types';
import { IProductResponse, ProductData } from 'utils/types';
import { TooltipTemplate } from 'components/TooltipTemplate';
import { Box } from '@mui/material';

const tooltipIcon =
  'https://media-dev.appcharge.com/media/6683d66f3ad9e626ecc051f5/1724936979813__75209c47-b991-4515-a23b-c3bd7ed7fa2a';

export const MightyFuSubProduct: React.FC<{
  subProduct: ProductData;
  tooltipLoadCallback?: (arr: string[]) => Promise<IProductResponse[]>;
}> = ({ subProduct, tooltipLoadCallback }) => {
  const [tooltip, setTooltip] = useState<any[]>([]);

  useEffect(() => {
    if (subProduct?.rarityProductInfo?.tooltip?.length > 0) {
      setTooltip(subProduct.rarityProductInfo.tooltip);
    }
  }, [subProduct]);

  const tooltipContent: IExtendedTooltipProps = useMemo(
    () => ({
      sections: tooltip,
      titleImg: subProduct.images.product,
      title: subProduct.displayName || '',
      tooltipLoadCallback: tooltipLoadCallback,
    }),
    [tooltip, tooltipTitleImage, tooltipLoadCallback],
  );

  return (
    <StyledMightyFuSubProduct className="sub-product">
      <Box className="product-info" gap={'2px'}>
        {subProduct.images.product && (
          <div className={'product-img'}>
            <img src={subProduct.images.product} alt="product" />
          </div>
        )}
        {subProduct.quantityDisplay && (
          <StyledQuantity title={subProduct.quantityDisplay}>
            <div className={'quantity_text'}>{subProduct.quantityDisplay}</div>
          </StyledQuantity>
        )}
      </Box>
      {tooltip && tooltip.length > 0 && (
        <TooltipTemplate
          buttonStyle={{
            position: 'absolute',
            right: '5px',
            height: '24px',
            zIndex: 2,
            cursor: 'pointer',
          }}
          content={tooltipContent}
          templateTooltipStyle={{
            background: '#023B50',
            minWidth: 160,
            borderRadius: '7px',
            zIndex: '5',
            padding: '8px',
          }}
        >
          <img
            className={'tooltip-icon'}
            src={tooltipIcon}
            alt={'tooltip-icon'}
          ></img>
        </TooltipTemplate>
      )}
    </StyledMightyFuSubProduct>
  );
};
